import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import LoadingWrapper from 'components/common/LoadingWrapper';

const InsuranceDataSummary = ({ summaryData, loading }) => {
  const { t } = useTranslation();

  return (
    <Grid container alignItems={'center'} sx={{ gap: '.5rem' }}>
      <span>{`${t('Offer.Edit.InsuranceData.Summary.Insurers')} `}</span>
      <Grid item xs={loading || !summaryData.insurerNames ? 4 : undefined}>
        <LoadingWrapper loading={loading || !summaryData.insurerNames}>
          <strong>{summaryData.insurerNames}</strong>
        </LoadingWrapper>
      </Grid>
      <span> {`${t('Offer.Edit.InsuranceData.Summary.MonthNo')} `}</span>
      <Grid item xs={loading || !summaryData.monthNo ? 1 : undefined}>
        <LoadingWrapper loading={loading || !summaryData.monthNo}>
          <strong>{summaryData.monthNo}</strong>
        </LoadingWrapper>
      </Grid>
      <span> {`${t('Offer.Edit.InsuranceData.Summary.StartDate')} `}</span>
      <Grid item xs={loading || !summaryData.startDate ? 2 : undefined}>
        <LoadingWrapper loading={loading || !summaryData.startDate}>
          <strong>{`${t('DATE', { date: summaryData.startDate })}`}</strong>
        </LoadingWrapper>
      </Grid>
    </Grid>
  );
};

InsuranceDataSummary.propTypes = {
  summaryData: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};
export default InsuranceDataSummary;
